import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/free-mode';
import { Autoplay, FreeMode } from 'swiper/modules';

// Import des images
import paychex from '../../assets/images/Paychex.png';
import tektinz from '../../assets/images/tektinz.png';
import momo from '../../assets/images/mtn.png';
import aws from '../../assets/images/aws.png';
import ittiq1 from '../../assets/images/ittiq 1.png';
import kaba from '../../assets/images/kaba.png';

const Partners = () => {
  // Tableau des partenaires pour faciliter la maintenance
  const partners = [
    { image: paychex, name: 'Paychex' },
    { image: tektinz, name: 'Tektinz' },
    { image: momo, name: 'MoMo' },
    { image: aws, name: 'AWS' },
    { image: ittiq1, name: 'Ittiq1' },
    { image: kaba, name: 'Kaba' },
  ];

  return (
    <div className="bg-white p-6 mt-5 mb-3">
      <Swiper
        modules={[Autoplay, FreeMode]}
        freeMode={true}
        loop={true}
        speed={3000}
        autoplay={{
          delay: 0,
          disableOnInteraction: false,
        }}
        breakpoints={{
          320: { slidesPerView: 2.5, spaceBetween: 10 },
          640: { slidesPerView: 3.5, spaceBetween: 15 },
          768: { slidesPerView: 4.5, spaceBetween: 20 },
          1024: { slidesPerView: 5.5, spaceBetween: 25 },
          1440: { slidesPerView: 6.5, spaceBetween: 30 },
        }}
        className="mySwiper"
      >
        {partners.map((partner, index) => (
          <SwiperSlide key={index}>
            <div className="partner-logo-container hover:scale-110 transition-transform duration-300">
              <img
                src={partner.image}
                alt={partner.name}
                className="h-12 w-auto mx-auto object-contain"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Partners;